import React from 'react';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { BORDER_TOP } from './constants';
import { BrandOverlineStyled } from './styled';
export function BrandOverline(props) {
    const { children, position = BORDER_TOP, borderColor = colorBrandYamahaRed, borderSize, isBorderWidthReset, isDefaultVerticalPadding = false, isBorderColorTransition = true, className, } = props;
    if (children) {
        return (React.createElement(BrandOverlineStyled, { className: className, position: position, borderColor: borderColor, borderSize: borderSize, isBorderWidthReset: isBorderWidthReset, isBorderColorTransition: isBorderColorTransition, isDefaultVerticalPadding: isDefaultVerticalPadding, "data-testid": "BrandOverline-wrapper" }, children));
    }
    return null;
}
BrandOverline.displayName = 'BrandOverline_Atom';
